export default "__VITE_ASSET__DZ44j5g___"